import { MessageCircle, Phone, Instagram, Mail, MapPin, Code2, Clock } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/site/Reveal";
import { Eyebrow } from "@/components/site/ui";
import { CONTACT, EKTIREN, waLink } from "@/data/site";
import ektirenLogo from "@/assets/brand/ektiren-logo.png";

export default function Iletisim() {
  const cards = [
    { icon: MessageCircle, label: "WhatsApp", value: CONTACT.phone, href: waLink(CONTACT.phoneRaw, "Merhaba İzmir Medya, bilgi almak istiyorum."), accent: "from-green-500 to-emerald-600", testid: "contact-whatsapp" },
    { icon: Phone, label: "Telefon", value: CONTACT.phone, href: `tel:${CONTACT.phoneRaw}`, accent: "from-cobalt to-cobalt-400", testid: "contact-phone" },
    { icon: Instagram, label: "Instagram", value: CONTACT.instagram, href: CONTACT.instagramUrl, accent: "from-neon-magenta to-neon-pink", testid: "contact-instagram" },
    { icon: Mail, label: "E-posta", value: CONTACT.email, href: `mailto:${CONTACT.email}`, accent: "from-neon-purple to-neon-magenta", testid: "contact-email" },
  ];

  return (
    <div className="pt-4">
      <section className="relative py-20 sm:py-28 overflow-hidden grain">
        <div className="absolute top-0 left-1/4 w-[420px] h-[420px] bg-cobalt/20 blur-[130px] rounded-full" />
        <div className="absolute bottom-0 right-1/4 w-[360px] h-[360px] bg-neon-magenta/20 blur-[130px] rounded-full" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <Eyebrow>İletişim</Eyebrow>
          <h1 className="mt-6 font-display font-extrabold text-5xl sm:text-7xl leading-[0.95]">
            <MaskedLines lines={["Hadi", "konuşalım"]} lineClassName="[&:nth-child(2)]:text-gradient" />
          </h1>
          <Reveal delay={0.4}>
            <p className="mt-7 max-w-xl text-lg text-slate-300">Projeni büyütmeye hazırsan, bir mesaj uzağındayız. En hızlı yanıt için WhatsApp'tan yaz.</p>
          </Reveal>

          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {cards.map((c, i) => (
              <Reveal key={c.label} delay={i * 0.07}>
                <a
                  href={c.href} target="_blank" rel="noreferrer"
                  data-testid={c.testid}
                  className="group block h-full p-6 rounded-3xl bg-ink-700 border border-white/10 hover:border-neon-magenta/50 transition-colors"
                >
                  <span className={`grid place-items-center w-12 h-12 rounded-2xl bg-gradient-to-br ${c.accent}`}>
                    <c.icon className="w-6 h-6 text-white" />
                  </span>
                  <div className="mt-5 font-mono text-xs uppercase tracking-widest text-slate-400">{c.label}</div>
                  <div className="mt-1 font-semibold text-lg group-hover:text-gradient break-all">{c.value}</div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Info + hours */}
      <section className="py-16 bg-ink-900/50 border-y border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid md:grid-cols-2 gap-6">
          <Reveal className="p-8 rounded-3xl glass border border-white/10">
            <MapPin className="w-8 h-8 text-neon-pink" />
            <h3 className="mt-4 font-display text-2xl font-bold">Konum</h3>
            <p className="mt-2 text-slate-300">{CONTACT.city}</p>
            <p className="mt-1 text-slate-400 text-sm">Tüm Türkiye'ye uzaktan ve yerinde hizmet veriyoruz.</p>
          </Reveal>
          <Reveal delay={0.1} className="p-8 rounded-3xl glass border border-white/10">
            <Clock className="w-8 h-8 text-cobalt-300" />
            <h3 className="mt-4 font-display text-2xl font-bold">Çalışma Saatleri</h3>
            <p className="mt-2 text-slate-300">Pazartesi – Cumartesi · 09:00 – 19:00</p>
            <p className="mt-1 text-slate-400 text-sm">WhatsApp mesajlarına 7/24 hızlı dönüş yapıyoruz.</p>
          </Reveal>
        </div>
      </section>

      {/* Ektiren dev contact */}
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <Reveal className="neon-border rounded-3xl glass-strong p-8 sm:p-10">
            <div className="flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
              <img src={ektirenLogo} alt="Ektiren Project" className="h-16 w-auto object-contain" />
              <div className="flex-1">
                <p className="inline-flex items-center gap-1.5 font-mono text-xs uppercase tracking-widest text-cobalt-300">
                  <Code2 className="w-3.5 h-3.5" /> Web Tasarım &amp; Geliştirme
                </p>
                <h3 className="mt-2 font-display text-2xl sm:text-3xl font-bold">Sen de site mi yaptırmak istiyorsun?</h3>
                <p className="mt-2 text-slate-400">Bu web sitesini geliştiren <span className="text-white font-semibold">{EKTIREN.name}</span> ile iletişime geç.</p>
              </div>
              <a
                href={waLink(EKTIREN.phoneRaw, "Merhaba Ektiren Project, web sitesi yaptırmak istiyorum.")}
                target="_blank" rel="noreferrer"
                data-testid="iletisim-ektiren-cta"
                className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-gradient-to-r from-cobalt to-neon-purple text-white font-semibold text-lg shrink-0 hover:scale-[1.03] transition-transform"
              >
                <MessageCircle className="w-5 h-5" /> {EKTIREN.phone}
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
